import axios from 'axios';

export const getCustomerKycApi = async (customerId) => {
  const response = await axios.get(`/admin/customer/${customerId}/kyc`);
  return response.data;
};

export const updateCustomerKycSettingsApi = async (customerId, settings) => {
  const response = await axios.put(
    `/admin/customer/${customerId}/kyc/settings`,
    settings
  );
  return response.data;
};

export const createCustomerKycPersonApi = async (customerId, person) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/kyc/people`,
    person
  );
  return response.data;
};

export const updateCustomerKycPersonApi = async (customerId, personId, person) => {
  const response = await axios.put(
    `/admin/customer/${customerId}/kyc/people/${personId}`,
    person
  );
  return response.data;
};

export const deleteCustomerKycPersonApi = async (customerId, personId) => {
  await axios.delete(`/admin/customer/${customerId}/kyc/people/${personId}`);
};

export const recordCustomerKycCompletionApi = async (
  customerId,
  personId,
  completedAt
) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/kyc/people/${personId}/completions`,
    { completedAt }
  );
  return response.data;
};

export const listCustomerKycEventsApi = async (customerId, personId) => {
  const response = await axios.get(
    `/admin/customer/${customerId}/kyc/people/${personId}/events`
  );
  return response.data;
};

export const KYC_RENEWAL_UNIT_OPTIONS = [
  { value: 'days', label: 'Days' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
];
